import axios from "axios";
import Config from "../../Config";
import {
   toast
} from "react-toastify";

const token = localStorage.getItem("auth_token")
const config = {
   headers: {
      Authorization: `Bearer ${token}`
   }
};

export const fetchSenders = async (setData, setLoading, setError) => {
   setLoading(true);
   setError(false);

   try {

      const [senderIdResponse, senderStatsResponse] = await Promise.all([
         axios.get(`https://backend.dealboxx.promo/api/admin/senderId`, config),
         axios.get('https://backend.dealboxx.promo/api/admin/statistics/senderId', config),
      ]);


      //  

      if (senderIdResponse.data.data.status_code === "000" && senderStatsResponse.data.data.status_code === "000") {
         setData({
            senderStats: senderStatsResponse.data.data.data,
            senderIdData: senderIdResponse.data.data.data,
         });
         // console.log(senderStatsResponse.data.data.data);
         setLoading(false);

      } else {
         setError(true);
         throw new Error([senderIdResponse.data.data.data.reason, senderStatsResponse.data.data.data.reason] || "Error Loading Sender Ids");

      }

   } catch (error) {
      // toast.error("Failed to Load Sender Ids");
      setLoading(false);
      setError(true);

   }

}




export const activateSender = async (values, senderId, {
   onSuccess,
   onError
}) => {

   try {
      console.log(values);
      const response = await axios.post(`https://backend.dealboxx.promo/api/admin/update/status/senderId/${senderId}`, values, config);

      console.log(response.data);
      if (response.data.data.status_code === "000") {
         onSuccess();

         toast.success('Sender ID Activated successfully!');
      } else {
         throw new Error(response.data.data.reason || 'Failed to activate sender ID');
      }

   } catch (error) {
      console.log(error);
      // onError(true);
      toast.error('Failed to activate sender ID!');

   }

}
export const deactivateSender = async (values, senderId, {
   onSuccess,
   onError
}) => {

   try {
      console.log(senderId);
      const response = await axios.post(`https://backend.dealboxx.promo/api/admin/update/status/senderId/${senderId}`, values, config);

      console.log(response.data);
      if (response.data.data.status_code === "000") {
         onSuccess();

         toast.success('Sender ID Deactivated successfully!');
      } else {
         throw new Error(response.data.data.reason || 'Failed to deactivate sender ID');
      }

   } catch (error) {
      console.log(error);
      // onError(true);
      toast.error('Failed to Suspend Sender ID!');

   }

}
